import PropTypes from 'prop-types';

export const contentType = PropTypes.shape({
    acceptButton: PropTypes.string,
    actionButton: PropTypes.string,
    color: PropTypes.string,
    declineButton: PropTypes.string,
    icon: PropTypes.string,
    left: PropTypes.shape({
        text: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.oneOf([
            'text',
            'image',
        ]),
    }),
    link: PropTypes.string,
    right: PropTypes.shape({
        text: PropTypes.string,
        title: PropTypes.string,
        type: PropTypes.oneOf([
            'text',
            'image',
        ]),
    }),
    text: PropTypes.string,
    title: PropTypes.string,
    type: PropTypes.oneOf([
        'text',
        'image',
        'file',
        'link',
        'updateRSVP',
        'updatePersonalInfo',
    ]),
    waitlistButton: PropTypes.string,
    waitlistText: PropTypes.string,
});

export const contentBlockType = PropTypes.shape({
    content: contentType,
    type: PropTypes.oneOf([
        'column',
        'cta',
        'ctac',
        'full',
        'icon',
        'registration',
        'spacer',
    ]),
});

export const eventSupportType = PropTypes.shape({
    email: PropTypes.string,
    eventUrl: PropTypes.string,
    phone: PropTypes.string,
    url: PropTypes.string,
});

export const groupDataType = PropTypes.shape({
    dateEnd: PropTypes.string,
    dateStart: PropTypes.string,
    eventID: PropTypes.string,
    groupID: PropTypes.string,
    isOpenGroup: PropTypes.bool,
    isWaitlistMode: PropTypes.bool,
    location: PropTypes.string,
    name: PropTypes.string,
    waitlistEnabled: PropTypes.bool,
});

export const settingsDataType = PropTypes.shape({
    documents: PropTypes.object,
    fields: PropTypes.object,
    landingTab: PropTypes.object,
    officialRules: PropTypes.string,
    permissions: PropTypes.object,
    secure: PropTypes.object,
});

export const inviteType = PropTypes.shape({
    data: groupDataType,
    guestInfo: PropTypes.object,
    id: PropTypes.string,
    rsvp: PropTypes.string,
    settings: settingsDataType,
    supportInfo: eventSupportType,
});

export const registrationType = PropTypes.shape({
    banner: PropTypes.shape({
        id: PropTypes.string,
        src: PropTypes.string,
    }),
    buttons: PropTypes.shape({
        corners: PropTypes.string,
        hover: PropTypes.bool,
        size: PropTypes.string,
        type: PropTypes.string,
    }),
    colors: PropTypes.shape({
        acceptButton: PropTypes.string,
        acceptButtonHover: PropTypes.string,
        actionButton: PropTypes.string,
        actionButtonHover: PropTypes.string,
        background: PropTypes.string,
        bannerText: PropTypes.string,
        declineButton: PropTypes.string,
        declineButtonHover: PropTypes.string,
        other: PropTypes.string,
        primaryText: PropTypes.string,
        secondaryText: PropTypes.string,
    }),
    customCode: PropTypes.shape({
        body: PropTypes.string,
        header: PropTypes.string,
    }),
    fonts: PropTypes.shape({
        primary: PropTypes.string,
        secondary: PropTypes.string,
    }),
    footerDisabled: PropTypes.boolean,
    footerText: PropTypes.string,
    headerDisabled: PropTypes.boolean,
    logo: PropTypes.shape({
        id: PropTypes.string,
        src: PropTypes.string,
    }),
    pages: PropTypes.shape({
        acceptConfirmation: PropTypes.arrayOf(contentBlockType),
        declineConfirmation: PropTypes.arrayOf(contentBlockType),
        landing: PropTypes.arrayOf(contentBlockType),
        openConfirmation: PropTypes.arrayOf(contentBlockType),
        waitlistConfirmation: PropTypes.arrayOf(contentBlockType),
    }),
});
